import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">视频精选</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精选热门八卦视频内容，深度解读娱乐圈最新动态
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
          {mediaData.slice(0, 3).map((item) => (
            <article key={item.id} className="group bg-foreground-900 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative aspect-video bg-foreground-800">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-foreground-900/30 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500 flex items-center justify-center group-hover:bg-primary-600 transition-colors">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-1 rounded bg-foreground-900/80 text-background-50 text-[10px] font-medium backdrop-blur-sm">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <span className="text-[10px] font-semibold text-primary-400 mb-1 block">{item.category}</span>
                <h3 className="font-heading font-semibold text-sm text-background-50 mb-2 group-hover:text-primary-300 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {item.views}
                  </span>
                  <span>{item.date}</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 max-w-4xl mx-auto mt-5">
          {mediaData.slice(3).map((item) => (
            <article key={item.id} className="group flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer">
              <div className="relative w-28 h-20 md:w-36 md:h-24 rounded-lg overflow-hidden flex-shrink-0 bg-foreground-900">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-foreground-900/20 flex items-center justify-center">
                  <div className="w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-xs ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <span className="text-[10px] font-semibold text-primary-600">{item.category}</span>
                <h3 className="font-semibold text-sm text-foreground-900 mt-0.5 group-hover:text-primary-600 transition-colors line-clamp-2">{item.title}</h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500 mt-1">
                  <span>{item.duration}</span>
                  <span>{item.views}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}